import axios from 'axios';
import { API_URL } from '../config/serverConfig';

// Base URL comes from serverConfig.js — change ENV there to switch environments
const baseURL = API_URL;

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
const token = localStorage.getItem('token');

if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
console.log('API Initialized with BaseURL:', api.defaults.baseURL);
console.log('API Headers:', api.defaults.headers);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const errData = error.response?.data || {};
    const errMsg = errData.error || errData.message || '';

    // If error is 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry && !window.location.pathname.includes('/login')) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return api(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;
      const refreshToken = localStorage.getItem('refresh_token');

      if (refreshToken) {
        try {
          // Attempt to refresh token
          // Note: We use axios directly to avoid interceptor loop if /refresh fails
          const response = await axios.post(`${api.defaults.baseURL}/auth/refresh`, {
            refresh_token: refreshToken
          });

          const { token: newToken, refresh_token: newRefreshToken } = response.data;

          // Save new tokens
          localStorage.setItem('token', newToken);
          localStorage.setItem('refresh_token', newRefreshToken);

          // Update header
          api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

          processQueue(null, newToken);
          isRefreshing = false;

          // Retry original request
          return api(originalRequest);
        } catch (refreshError) {
          processQueue(refreshError, null);
          isRefreshing = false;
          console.error('Token refresh failed:', refreshError);
          // If refresh fails, logout
          handleLogout();
          return Promise.reject(refreshError);
        }
      } else {
        isRefreshing = false;
        handleLogout();
      }
    }
    return Promise.reject(error);
  }
);

function handleLogout() {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  delete api.defaults.headers.common['Authorization'];
  if (!window.location.pathname.includes('/login')) {
    window.location.href = '/login';
  }
}

export default api;
